<app-langding-page-nav-bar></app-langding-page-nav-bar>

<div class="app-content container " >
  <div class="suggestion-page-layout">
    <div class="suggestion-page-menu landing-side1">
      <div class="hpanel gs-cardgs-card" *ngIf="WidgetList">
        <div class="pad-0 border-radius-top-left-right-6">
          <ul>
            <li *ngFor="let item of WidgetList" class="navmenu" (click)="clickmenu(item)"
              [ngClass]="{ active: selectedmenu.widgetName == item.widgetName }" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <a class="navIteam">
                <div class="nav-margin"> {{item.widgetDesc}}</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="suggestion-page-content">
      <app-suggestions [selectedMenu]="selectedmenu"></app-suggestions>
    </div>
  </div>
</div>
